<template>
  <div class="details">
    <div class="header">
      <el-button
        type="primary"
        @click="edit"
      >
        编辑
      </el-button>
    </div>
    <info-panel :padding="24">
      <el-row>
        <el-col>
          <info-item label="考试须知">
            <div v-html="result.examPurchaseNotice" />
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';

import axClient from '@/services';

export default {
  name: 'AccountDetails',
  components: {
    infoPanel,
    infoItem,
  },
  data() {
    return {
      result: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 详情
    async getInfo() {
      this.result = await axClient.config.getExamPurchaseNotice();
    },
    edit() {
      this.$router.push({ name: 'ConfigExamEdit' });
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .header {
    display: flex;
    justify-content: flex-end;
    padding: 15px 0;
  }
}
</style>